var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPins(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.5C9.9087 20.5 8.38258 19.8679 7.25736 18.7426C6.13214 17.6174 5.5 16.0913 5.5 14.5",
    stroke: "#161616",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.5C9.5 7.709 5.5 11.5 5.5 11.5C5.5 11.5 1.5 7.709 1.5 5.5C1.5 4.43913 1.92143 3.42172 2.67157 2.67157C3.42172 1.92143 4.43913 1.5 5.5 1.5C6.56087 1.5 7.57828 1.92143 8.32843 2.67157C9.07857 3.42172 9.5 4.43913 9.5 5.5V5.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5C23.5 15.814 17.5 22 17.5 22C17.5 22 11.5 15.814 11.5 12.5C11.5 10.9087 12.1321 9.38258 13.2574 8.25736C14.3826 7.13214 15.9087 6.5 17.5 6.5C19.0913 6.5 20.6174 7.13214 21.7426 8.25736C22.8679 9.38258 23.5 10.9087 23.5 12.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5C6.05228 6.5 6.5 6.05228 6.5 5.5C6.5 4.94772 6.05228 4.5 5.5 4.5C4.94772 4.5 4.5 4.94772 4.5 5.5C4.5 6.05228 4.94772 6.5 5.5 6.5Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5C18.6046 14.5 19.5 13.6046 19.5 12.5C19.5 11.3954 18.6046 10.5 17.5 10.5C16.3954 10.5 15.5 11.3954 15.5 12.5C15.5 13.6046 16.3954 14.5 17.5 14.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPins);
export default __webpack_public_path__ + "static/media/MapPins.8015636d.svg";
export { ForwardRef as ReactComponent };